import axios from "axios";

// IP never changes during a session — cache the result permanently.
// Concurrent callers share one in-flight promise; subsequent callers get the cached value instantly.
let _cached = null;
let _promise = null;

const getIP = () => {
    if (_cached) return Promise.resolve(_cached);
    if (_promise) return _promise;
    // api.ipify.org is a public third party responding with a wildcard CORS
    // origin, which is incompatible with a credentialed request — override
    // the global axios.defaults.withCredentials=true (needed for jwt_token
    // to reach our own Node origin) back off for this specific call.
    _promise = axios.get('https://api.ipify.org?format=json', { withCredentials: false })
        .then(res => {
            _cached = res;
            _promise = null;
            return res;
        })
        .catch(err => {
            _promise = null;
            throw err;
        });
    return _promise;
};

export default getIP;